import { AppState } from '../../../store/store'

export const selectMedarbetare = (state: AppState) => state.medarbetareReducer.data
export const selectMedLoading = (state: AppState) => state.medarbetareReducer.loading
